import styles from './index.css';

import * as React from 'react';
import classNames from 'classnames';

import {Icon} from '@shared/Components';
import {TBusinessStatus} from '../../../Definitions';
import {getLabel} from '../../../Config/labels';

type TOpeningIndicatorProps = {
    isOpen: boolean|undefined;
    businessStatus?: TBusinessStatus;
    onClick?: () => void;
};
export default ({isOpen, businessStatus, onClick}: TOpeningIndicatorProps) => (
    <div
        onClick={onClick}
        className={classNames(
            styles.openIndicator,
            Boolean(onClick) && styles.isClickable
        )}
    >
        {
            (isOpen !== undefined && businessStatus === 'OPERATIONAL')
                ? (
                    <div className={styles.trafficLight}>
                        <div className={classNames(
                            styles.light,
                            isOpen && styles.isOpen,
                        )}></div>
                        {getLabel(isOpen ? 'IS_OPEN' : 'IS_CLOSED')}
                    </div>
                )
                : (businessStatus === 'CLOSED_PERMANENTLY' || businessStatus === 'CLOSED_TEMPORARILY') && (
                    <div className={styles.currentState}>
                        {getLabel(businessStatus)}
                    </div>
                )
        }
        {
            Boolean(onClick) &&
                <Icon
                    name="ChevronDown"
                    className={styles.icon}
                />
        }
    </div>
);
